module.exports = __webpack_public_path__ + "static/media/010_Bitmap.27af3f2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/mashery/010_Bitmap.png
// module id = 557
// module chunks = 0